import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';

export const usePrescriptionTasksEnabled = (): boolean => {
  return useFeatureIsOn(GROWTHBOOK_FEATURE_FLAGS.PRESCRIPTION_TASKS);
};
